import { render, staticRenderFns } from "./wangEditor.vue?vue&type=template&id=b09b7ce0"
import script from "./wangEditor.vue?vue&type=script&lang=js"
export * from "./wangEditor.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports